// @ts-ignore
import CurrentUserDto from '../../generated/Result/Security/Models/CurrentUserDto';
import { RESET_STATE } from '../types/global';
import {
  CURRENT_USER_FETCHED,
  USER_AUTHENTICATED,
  USER_UNAUTHENTICATED,
  AUTH_ERROR,
  CLEAR_AUTH_ERROR,
  CHECK_LOGIN_AVAILABLE,
  CHECK_EMAIL_AVAILABLE,
  UPDATE_PROFILE,
  CHANGE_PASSWORD,
  RESET_SCOPEDROLES,
  GET_SCOPEDROLES,
  USER_SIGN_VALIDATION,
  TRAINING_NOTIFICATION,
  SET_CAPTCHA_INVISIBLE,
  SET_CAPTCHA_NORMAL,
  SET_MSAL_INSTANCE,
  SET_SSO_AUTHENTICATED,
  SET_MFA_TOKEN_TYPE
} from '../types/security';

export interface SecurityState {
  authError: any,
  authenticated: boolean,
  user: CurrentUserDto,
  scopedRoles: number[],
  isLoginAvailable: boolean,
  isEmailAvailable: boolean,
  trainingNotification: any,
  profileUpdated: boolean,
  passwordUpdated: boolean,
  physicianIsLimited: any,
  captchaState: 'normal' | 'invisible' | 'compact',
  deceased: boolean,
  ssoAuthenticated: boolean,
  msalInstance: any,
  mailingAddressEnabled: boolean,
  mailingAddressVerificationEnabled: boolean,
  mfaEnabled: boolean
  mfaTokenTypeId: null
}

const INITIAL_STATE: SecurityState = {
  authError: null,
  authenticated: false,
  user: null,
  scopedRoles: null,
  isLoginAvailable: null,
  isEmailAvailable: null,
  trainingNotification: null,
  profileUpdated: null,
  passwordUpdated: null,
  physicianIsLimited: null,
  captchaState: 'invisible',
  deceased: false,
  ssoAuthenticated: false,
  msalInstance: null,
  mailingAddressEnabled: false,
  mailingAddressVerificationEnabled: false,
  mfaEnabled: false,
  mfaTokenTypeId: null
};

const securityReducer = function (state: SecurityState = INITIAL_STATE, action): SecurityState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case CURRENT_USER_FETCHED:
      return {
        ...state,
        user: action.payload,
        physicianIsLimited: action?.payload?.physicianIsLimited ?? false,
        deceased: action?.payload?.deceased ?? false,
      };
    case USER_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
        physicianIsLimited: action?.payload?.physicianIsLimited ?? false,
        deceased: action?.payload?.deceased ?? false,
        ssoAuthenticated: action?.payload?.ssoAuthenticated,
        mailingAddressEnabled: action?.payload?.mailingAddressEnabled ?? false,
        mailingAddressVerificationEnabled: action?.payload?.mailingAddressVerificationEnabled ?? false,
        mfaEnabled: action?.payload?.mfaEnabled ?? false,
        mfaTokenTypeId: action?.payload?.mfaTokenTypeId ?? null
      };
    case USER_UNAUTHENTICATED:
      return { ...state, authenticated: false, user: null };
    case AUTH_ERROR:
      return {
        ...state, authenticated: false, authError: action.payload, user: null,
      };
    case CLEAR_AUTH_ERROR:
      return { ...state, authError: null };
    case CHECK_LOGIN_AVAILABLE:
      return { ...state, isLoginAvailable: action.payload.available };
    case CHECK_EMAIL_AVAILABLE:
      return { ...state, isEmailAvailable: action.payload.available };
    case UPDATE_PROFILE:
      return { ...state, profileUpdated: action.payload };
    case TRAINING_NOTIFICATION:
      return { ...state, trainingNotification: action.payload };
    case CHANGE_PASSWORD:
      return { ...state, passwordUpdated: action.payload };
    case GET_SCOPEDROLES:
      return { ...state, scopedRoles: action.payload };
    case RESET_SCOPEDROLES:
      return { ...state, scopedRoles: null };
    case USER_SIGN_VALIDATION:
      return { ...state, user: { ...state.user, requiresSignature: !(action.payload.validated) } };
    case SET_CAPTCHA_INVISIBLE:
      return { ...state, captchaState: 'invisible' };
    case SET_CAPTCHA_NORMAL:
      return { ...state, captchaState: 'normal' };
    case SET_MSAL_INSTANCE:
      return { ...state, msalInstance: action.payload };
    case SET_SSO_AUTHENTICATED:
      return { ...state, ssoAuthenticated: action.payload };
    case SET_MFA_TOKEN_TYPE:
      return { ...state, mfaTokenTypeId: action.payload };
    default:
      return state;
  }
};

export default securityReducer;
